<template>
  <div class="wrap">
    <div class="main">
      <div class="login">
        <i class="iconfont icon-back-left" @click="goBack"></i>
        <!-- <img src="@img/logo_white.png"> -->
        <div class="logo">
            <img src="@img/bitfinex-logo.png" alt="">
            <span>BITFINEX</span>
          </div>
      </div>
      <div class="login-info">
        <label>
          <i class="iconfont icon-zhanghao"></i>
          <input type="text" v-model="uname" :placeholder="lang.enaccount">
        </label>
        <label>
          <i class="iconfont icon-mima"></i>
          <input :type="[showPwd01?'text':'password']"  v-model.trim="pwd" :placeholder="lang.enpassword">
          <i class="iconfont" :class="[showPwd01?'icon-yanjing_kai':'icon-yanjing_bi']" @click="showPwd01=!showPwd01"></i>
        </label>
        <label>
          <i class="iconfont icon-mima"></i>
          <input :type="[showPwd02?'text':'password']" v-model.trim="comPwd" :placeholder="lang.enpassagain">
          <i class="iconfont" :class="[showPwd02?'icon-yanjing_kai':'icon-yanjing_bi']" @click="showPwd02=!showPwd02"></i>
        </label>
        <label>
          <i class="iconfont icon-yaoqingmatianchong"></i>
          <input type="text" v-model="inviteCode" :placeholder="lang.yqm" :readonly="isreadonly">
        </label>
<!--        <label>-->
<!--          <i class="iconfont icon-mima1"></i>-->
<!--          <input type="text" v-model.trim="vcode" :placeholder="lang.yzm">-->
<!--          <img @click="getCode()" :src="yzmSrc" class="yzm">-->
<!--        </label>-->
      </div>
      <div class="login-footer">
        <p class="login-btn" @click="zhuce">{{lang.reg}}</p>
        <p class="bottom">
          <router-link to="/Login">{{lang.hasAcc}}</router-link>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {APP_INFO} from '@/assets/js/config'
  export default {
    data() {
      return {
        regPar:'',
        uname: '',
        pwd: '',
        comPwd: '',
        inviteCode:'',
        vcode: '',
        yzmSrc: '',
        reging: false,
        isreadonly:false,
        langType:'',
        cs_url:'',
        showPwd01: false,
        showPwd02: false,
      }
    },
    created() {
      // this.getCode();
      // this.getToken();
      this.getSysConf();
      // this.agent = this.$route.query.agent || '';
      // this.isreadonly = this.agent?true:false;
      if (this.$route.query.code) {
        this.inviteCode = this.$route.query.code
        this.isreadonly = true
      }
    },
    computed: {
      ...mapState(['lang'])
    },
    methods: {
      goBack(){
        this.$router.go(-1);
      },
      // getCode() {
      //   this.$indicator.open(this.lang.loading);
      //   this.$xhrGet('/index/vcode')
      //     .then(res => {
      //       this.$indicator.close();
      //       if (res.err == 0) {
      //         this.yzmSrc = res.data
      //       }
      //     })
      // },
      // getToken(){
      //   this.$doRequest('get', '/index/getToken')
      //     .then(res => {
      //       localStorage.setItem('tk', res.data)
      //       this.getCode();
      //       this.getSysConf();
      //     })
      // },
      getSysConf(){
        this.$indicator.open(this.lang.loading);
        this.$doRequest('get', '/system/config')
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.cs_url = res.data.cs_url;
              this.$store.dispatch('set_siteName',res.data.siteName);
              this.$store.dispatch('set_siteKefu',this.cs_url);
              this.$store.dispatch('set_appDownLoad',this.appDownload);
              document.title = res.data.siteName;
            }
          })
      },
      setLang(lan){
        let choselang = lan?'en':'cn';
        this.$doRequest('post', '/index/setLang')
          .then(res => {
            if (res.data.err == 0) {
              let lang = {};
              for(let i in language){
                lang[i] = language[i][lan]
              }
              this.$store.dispatch('set_ulang',choselang);
            }
          })
      },
      //表单验证
      from_verifica() {
        // 用户名
        if(this.uname == ''){
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.enaccount,
              confirmButtonText: this.lang.confirm
            });
            return false
        }
        // 密码
        if(this.pwd == ''){
          this.$messagebox({
              title: this.lang.tip,
              message: this.lang.enpassword,
              confirmButtonText: this.lang.confirm
            });
            return
        }
        // 邀请码
        if (this.invite_code == ''){
          this.$messagebox({
              title: this.lang.tip,
              message: this.lang.yqm,
              confirmButtonText: this.lang.confirm
            });
             return false
        }
        return true
      },
      zhuce() {
        if (!this.from_verifica()) return
        if (this.reging) return;
        if (this.comPwd != this.pwd) {
          this.$messagebox({
            title: this.lang.tip,
            message: this.lang.noSame,
            confirmButtonText: this.lang.confirm
          });
          return false;
        }
        // if (!this.vcode) {
        //   this.$messagebox({
        //     title: this.lang.tip,
        //     message: this.lang.yzm,
        //     confirmButtonText: this.lang.confirm
        //   });
        //   return false;
        // }
        this.reging = true;
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/member/reg', {
            uname: this.uname,
            pwd: this.pwd,
            // vcode: this.vcode,
            inviteCode: this.inviteCode,
            // sg:APP_INFO.SG
          })
          .then(res => {
            this.$indicator.close();
            this.reging = false

            if (res.data.err == 0) {
              this.$toast({
                message: this.lang.regsucc,
                iconClass: 'iconfont icon-chenggong',
                duration: 2000
              })
              // this.getuserinfo();
              if(this.isAPP == 'app'){
                sessionStorage.setItem('url',res.data.api);
              }
              this.$store.dispatch('set_userInfo', { uname: this.uname, blc: res.data.blc, vip: res.data.vip })
              sessionStorage.setItem('tk', res.data.tk)
              setTimeout(() => {
                this.$router.push('/')
              }, 2000)
            } else if (res.data.err == 102) {
              sessionStorage.setItem('tk', res.data.tk);
              this.inviteCode = '';
              this.zhuce();
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
              // this.getCode();
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.reging = false
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      }
    }
  }
</script>
<style scoped >
  .logo img{
    width: 36px;
  }
  .logo span{
    font-size: 36px;
    color: #dbf1ff;
  }

  .login {
    width: 100%;
    height: 150px;
    background: url(../assets/images/logo-bg.png) no-repeat center center;
    background-size: cover;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .login .iconfont {
    position: absolute;
    width: 40px;
    height: 40px;
    line-height: 40px;
    top: 0;
    left: 12px;
    color: #fff;
  }

  .login-info  label {
    position: relative;
    width: 80%;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
    display: flex;
    font-size: 16px;
    align-items: center;
    border: 1px solid #aaa;
    border-radius: 5px;
  }
  .login-info  label i {
    display: inline-block;
    width: 40px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-right: 1px solid #aaa;
    color: #999;

  }
  .login-info  label i:last-child{
    border:none;
  }

  .login-info  label input {
    flex: 1;
    height: 40px;
    background: none;
    padding-left: 5px;
  }

  .login-info  label img {
    position: absolute;
    top: 1px;
    right: 1px;
    height: 36px;
  }

  .login-footer {
    width: 80%;
    margin: 10px auto;
    color: #999;
  }
  .login-footer p {
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    margin: 12px auto;
    font-size: 16px;
    text-align: center;
  }
  .login-footer p a {
    color: #999;
  }

  .login-footer .login-btn {
    background: #0183FF;
    margin-top: 20px;
    color: #fff;
  }

  .langue {
    display: flex;
    justify-content: space-around;
    color: #333;
  }
  .langue span {
    flex: 1;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    border: 1px solid #0183FF;

    &:last-child {
      margin-left: 12px;
    }
  }
  .bottom{
    position: relative;
  }
  .bottom::before{
    position: absolute;
    content: '';
    top:50%;
    left:0;
    right:0;
    height: 1px;
    background: #ddd;
  }
  .bottom a{
    padding:0 10px;
    position: relative;
    background: #fff;
    z-index: 1;
  }
</style>